<template>
  <el-date-picker
    v-model="config.value"
    type="monthrange"
    range-separator="至"
    start-placeholder="开始月份"
    end-placeholder="结束月份"
    :value-format="'yyyy-MM-dd'"
    :clearable="!config.noCleara"
    unlink-panels
    @change="changePicker"
    :picker-options="pickerOptions"
  />
</template>
<script>
export default {
  name: 'DatePickerCustom',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  computed: {
    timeZone() {
      return this.config.timeZone === undefined ? 8 : this.config.timeZone
    }
  },
  data() {
    return {
      pickerDate: {},
      pickerOptions: {
        disabledDate: (time) => {
          const timeValue = time.getTime()
          const pickerDate = this.pickerDate
          const { maxChange, subtractDay, endTime, infinite } = this.config
          let maxTime = infinite
            ? 9999999999999
            : this.$cTime()
              .add(this.timeZone, 'h')
              .endOf('day')
              .valueOf()
          let minTime = 0
          if (endTime) {
            maxTime = this.$dayjs(endTime)
              .endOf('day')
              .valueOf()
          }
          if (pickerDate?.minDate && !pickerDate.maxDate) {
            // 最大选取周期
            if (maxChange) {
              const maxChange_max = this.$dayjs(pickerDate.minDate)
                .add(maxChange[0], maxChange[1])
                .startOf('day')
                .valueOf()
              const maxChange_min = this.$dayjs(pickerDate.minDate)
                .subtract(maxChange[0], maxChange[1])
                .startOf('day')
                .valueOf()
              if (maxChange_max < maxTime) {
                maxTime = maxChange_max
              }
              if (maxChange_min > minTime) {
                minTime = maxChange_min
              }
            }
          }
          if (subtractDay) {
            // 能选择的最大周期
            const minTime_min = this.$cTime()
              .add(this.timeZone, 'h')
              .subtract(subtractDay[0], subtractDay[1])
              .startOf('day')
              .valueOf()
            if (minTime_min > minTime) {
              minTime = minTime_min
            }
          }
          return timeValue >= maxTime || timeValue <= minTime
        },
        onPick: (obj) => {
          this.pickerDate = obj
        },
      }
    }
  },
  methods: {
    changePicker(value) {
      this.$emit('handleDateChange', this.config, value)
    }
  }
}

</script>
<style lang="scss">
.quick-warp{
    display:flex
}
</style>
